const Wishlist=()=>{
    return <div>
        <h1>WishList</h1>;
    </div>
};

export default Wishlist;